/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useState} from 'react';
import {getSublayerTree} from '../../../maps/helpers/MapViewUtils';
import Opacity from './Opacity';
import Sublayer from './Sublayer';
import {LayerProps, Updated} from './types';

/**
 * @SubLayers
 *
 * Defines the SubLayers Tab / Section of the OperationalLayers
 */
const Sublayers = ({
  sublayers,
  layerTitle,
  opacity,
  sublayersVisibility,
  onVisibilityChange,
  changeOpacity
}: LayerProps) => {
  const [visibility, setVisibility] = useState(sublayersVisibility);
  const sublayerTree = getSublayerTree(sublayers, true, true);

  useEffect(() => {
    setVisibility(sublayersVisibility);
  }, [sublayersVisibility]);

  const handleCheckboxState = useCallback((
    sublayerId: string,
    visible: boolean
  ) => {
    const nextState = [...visibility];
    nextState?.forEach((i) => {
      if (i?.layerTitle === layerTitle &&
        i?.sublayerId === sublayerId) {
        i.visibility = !visible;
      }
    });
    setVisibility(nextState);

    const updated: Updated = {
      layerTitle,
      sublayerId,
      visible : !visible
    };

    onVisibilityChange(updated);
  }, [visibility, layerTitle]);

  const getVisibility = useCallback((sublayerId) => {
    const found = visibility?.find((layer) => {
      return layer?.layerTitle === layerTitle &&
      layer?.sublayerId === sublayerId;
    });
    return found ? found.visibility : false;
  }, [visibility, layerTitle]);

  return (
    <>
      <div className='subLayers'>
        {sublayerTree?.children?.map((sublayer, index) => (
          <Sublayer key={index}
            sublayer={sublayer}
            layerTitle={layerTitle}
            getVisibility={getVisibility}
            handleCheckboxState={handleCheckboxState}/>
        ))}
      </div>
      <br />
      <Opacity changeOpacity={changeOpacity}
        opacity={opacity}
        title={layerTitle} />
    </>
  );
};

export default Sublayers;
